const AnnoncementBar = function() {
  function AnnoncementBar() {
    this.selector = {
      slides: document.querySelectorAll('.announcement-for-mobile .slide'),
      slder: document.querySelector('.announcement-for-mobile')
    }
    this.state = {
      currentSlide: 0,
      intervalId: null
    }
    this.load();
  }
  AnnoncementBar.prototype.load = function() {
    var _ = this;
    const autorotateslide = parseInt(_.selector.slder.dataset.autorotateSpeed) * 1000;
    if(window.innerWidth < 769) {
      _.state.intervalId = setInterval(() => {
        _.showslide(_.state.currentSlide + 1);
      }, autorotateslide); // Change slide every 3 seconds
    }
    window.addEventListener('resize', () => {
      if(window.innerWidth < 768) {
        clearInterval(_.state.intervalId);
      } else {
        _.state.intervalId = setInterval(() => {
          _.showslide(_.state.currentSlide + 1);
        }, autorotateslide); // Change slide every 3 seconds
      }
    })

  }
  AnnoncementBar.prototype.showslide = function(n) {
    var _ = this;
    _.selector.slides[_.state.currentSlide].classList.remove('active');
    _.state.currentSlide = (n + _.selector.slides.length) % _.selector.slides.length;
    _.selector.slides[_.state.currentSlide].classList.add('active');
  }
  AnnoncementBar = new AnnoncementBar;
}
AnnoncementBar();